<app-product-search [params]="productParams" [showSupplier]="false"></app-product-search>
